export default {
  container: {
    flexDirection: 'column',
    flexBasis: '175px',
    pt: '60px',
    display: ['flex', 'none', 'none', 'none', 'flex'],
  },
  aside: {
    flexDirection: 'column',
    overflowY: 'auto',
    position: 'sticky',
    top: '88px',
    '& .active': { textDecoration: 'underline' },
  },
  navTitle: {
    fontSize: '16px',
    lineHeight: '24px',
    m: 0,
    fontWeight: 600,
    color: '#475467',
    mb: '8px',
  },
  navLink: {
    textDecoration: 'none',
    transition: 'all ease 250ms',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#667085',
    py: '8px',
  },
};
